export enum TechnicalDatasheetType {
  TUFT
}
